import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getRegionLoading: false,
  getRegionFailed: false,
  getRegionReject: false,
  getRegionMessage: [],
  region: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_REGION_LOADING: {
      return {
        ...state,
        getRegionLoading: true,
        getRegionFailed: false,
        getRegionReject: false,
        getRegionMessage: [],
        region: [],
      };
    }
    case actionTypes.GET_REGION_SUCCESS: {
      return {
        ...state,
        getRegionLoading: false,
        getRegionFailed: false,
        getRegionReject: false,
        getRegionMessage: [],
        region: action.payload.regions,
      };
    }
    case actionTypes.GET_REGION_FAILED: {
      return {
        ...state,
        getRegionLoading: false,
        getRegionFailed: true,
        getRegionReject: false,
        getRegionMessage: [],
        region: [],
      };
    }
    case actionTypes.GET_REGION_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getRegionLoading: false,
        getRegionFailed: false,
        getRegionReject: true,
        getRegionMessage: message,
        region: [],
      };
    }

    default:
      return state;
  }
};
